export const statusList = [
    { value: "1", name: "Activo" },
    { value: "0", name: "Desactivado" },
  ]